import BaseAPI from "../api";

const path: string = "dashboard/summary";
const pathPublic: string = "dashboard-publish";

export interface dashboardProps {
  format?: string;
  keyword?: string;
  idTrack?: number;
  idBudget?: number;
  idClusters?: number;
  idType?: number;
  idPlan?: number;
  idTactics?: number;
  idStrategy?: number;
  idDepartment?: number;
  idFiscalyear?: number;
}

export class DashboardApi extends BaseAPI {
  static download(props: dashboardProps): Promise<any> {
    return this.api
      .get(`${path}/download`, {
        params: { ...props },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }
  static strategy(props: dashboardProps): Promise<any> {
    return this.api
      .get(`${path}-by-strategy`, { params: { ...props } })
      .then((res) => res);
  }
  static projectTrackStatus(props: dashboardProps): Promise<any> {
    return this.api
      .get(`${path}-by-track-status`, { params: { ...props } })
      .then((res) => res);
  }
  static projectTrackPlan(props: dashboardProps): Promise<any> {
    return this.api
      .get(`${path}-by-complete-in-plan`, { params: { ...props } })
      .then((res) => res);
  }
  static projectTrackDepartment(props: dashboardProps): Promise<any> {
    return this.api
      .get(`${path}-by-department`, { params: { ...props } })
      .then((res) => res);
  }

  // public
  static getBudgetSourcePublic(idFiscalyear: number): Promise<any> {
    return this.api.get(`${pathPublic}/budget-by-source`, { params: { idFiscalyear: idFiscalyear } }).then((res) => res);
  }
  static getBudgetDepartmentPublic(idFiscalyear: number): Promise<any> {
    return this.api.get(`${pathPublic}/budget-by-department`, { params: { idFiscalyear: idFiscalyear } }).then((res) => res);
  }
}
